import MainLayout from "../../layout/MainLayout";
import OverviewSection from "../../components/OverviewSection";
import FilterSection from "../../components/FilterSection";
import DataTable from "../../common/Tables/DataTable";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { actionPost, getApi } from "../../services/api";
import useExpiredToken from "../../utils/useExpiredToken";
import { getCallTableColumns, ShowData } from "../../utils/ShowData";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import AssignedCallDetails from "../../components/models/AssignedCallDetails";
import { filterDataFunc, roleNames } from "../../constant";

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [overviewData, setOverviewData] = useState(null);
  const token = useSelector((state) => state.auth.jwtToken);
  const { searchText } = useSelector((state) => state.search);
  const expireToken = useExpiredToken();
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const columns = getCallTableColumns((record) => {
    setSelectedRow(record);
    setIsDetailsModalOpen(true);
  });

  // const fetchData = async () => {
  //   const res = await actionPost("calls/summary", token, "READ_ALL", {}, expireToken);
  //   const data = await processEncryptedResponse(res);

  //   if (data) {
  //     setData(data);
  //   }
  // };

  const fetchOverview = async () => {
    const res = await getApi("calls/overview", token, expireToken);
    const data = await processEncryptedResponse(res);
    if (data) {
      setOverviewData(data);
    }
  };

  const mappedData = data?.map((item) => ShowData(item, roleNames.qa));

  const filteredData = filterDataFunc(mappedData, searchText);

  useEffect(() => {
    // fetchData();
    fetchOverview();
  }, []);

  const handleCancel = () => {
    setIsDetailsModalOpen(false);
  };

  return (
    <>
      <>
        <div className="container-fluid">
          <div className="">
            <OverviewSection overviewData={overviewData} />
            {/* <div>
              <FilterSection />
            </div> */}
          </div>
          <DataTable
            updatedColumns={columns}
            callApiArgs={{
              endpoint: "calls/summary",
              bodyData: {
                action: "READ_ALL",
                input: {},
              },
              apiMethod: "post",
            }}
          />
        </div>
      </>
      <AssignedCallDetails
        open={isDetailsModalOpen}
        handleCancel={handleCancel}
        formData={selectedRow}
      />
    </>
  );
};

export default Dashboard;
